import types from './types';

const getUrl = ({ ripId, id, product }) => `/rip/${ripId}/simulations/${id}/${types[product].entryPoint}`;

export default getUrl;
